export default function($) {
  let caseStudiesHomeSwiper = document.querySelector('.js-case-studies-home-slider');

  const homeSwiper = new Swiper('.js-home-slider', {
    slidesPerView: 1,
    spaceBetween: 16,
    loop: true,
    pagination: {
      el: "#home-swiper-pagination",
      clickable: true,
    },
    autoplay: {
      delay: 7000,
      disableOnInteraction: false,
      pauseOnMouseEnter: true
    },
    speed: 1000,
  });

  const caseStudiesHomeSwiperParams = {
    loop: true,
    slidesPerView: 1,
    spaceBetween: 16,
    pagination: {
      el: ".case-studies-home-swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      480: {
        slidesPerView: 1,
        spaceBetween: 32,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 24,
      },
    },
    on: {
      destroy: function() {
        $('.case-studies-home-swiper-pagination').hide();
      },
      init: function() {
        $('.case-studies-home-swiper-pagination').show();
      },
    },
  };

  const caseStudiesSwiper = new Swiper('.js-case-studies-slider', {
    slidesPerView: 1,
    loop: true,
    pagination: {
      el: ".case-studies-swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
      enabled: false
    },
    breakpoints: {
      480: {
        slidesPerView: 1,
        spaceBetween: 16,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 24,
      },
      1024: {
        navigation: {
          enabled: true
        },
        slidesPerView: 3,
        spaceBetween: 32,
      },
      1280: {
        slidesPerView: 4,
        spaceBetween: 32,
      },
    },
  });

  const qualitySwiper = new Swiper('.js-quality-slider', {
    slidesPerView: 1,
    spaceBetween: 16,
    loop: false,
    scrollbar: {
      el: ".swiper-scrollbar",
      hide: false,
    },
    breakpoints: {
      480: {
        slidesPerView: 1,
        spaceBetween: 16,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 24,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 32,
      },
      1280: {
        slidesPerView: 4,
        spaceBetween: 32,
      },
    },
  });

  const productPresentationSwiper = new Swiper('.js-product-presentation-slider', {
    slidesPerView: 1,
    loop: true,
    pagination: {
      el: ".product-presentation-swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
      enabled: false
    },
    breakpoints: {
      1024: {
        navigation: {
          enabled: true
        },
      },
    },
  });


  swiperDisplay();

  $(window).resize(function() {
    swiperDisplay();
  })

  function swiperDisplay() {
    if( $(window).width() < 1024 ) {
      if( $('.js-case-studies-home-slider').length > 0 && !caseStudiesHomeSwiper.initialized ) {
        caseStudiesHomeSwiper = new Swiper('.js-case-studies-home-slider', caseStudiesHomeSwiperParams);
      };
    }

    else {
      if( $('.js-case-studies-home-slider').length > 0 && caseStudiesHomeSwiper.initialized ) {
        caseStudiesHomeSwiper.destroy(false,true);
        $('.js-case-studies-home-slider').find('.swiper-wrapper').removeAttr('style');
        return;
      } else {
        $('.case-studies-home-swiper-pagination').hide();
      };
    }
  }
}
